<div class="card-soft p-4 container">
  <h5 class="section-title mb-4">Pick-Up & Drop-Off</h5>

  <div class="row g-3 pickup-drop-row">
    <!-- Pickup Card -->
    <div class="col-12 col-md-6">
      <div class="location-card pickup-card">
        <div class="location-header">
          <i class="fa-solid fa-location-dot location-icon"></i>
          <span class="location-label">PICKUP</span>
        </div>
        <div class="location-value">{{ pickup || 'Navi Mumbai' }}</div>
      </div>
    </div>

    <!-- Drop Card -->
    <div class="col-12 col-md-6">
      <div class="location-card drop-card">
        <div class="location-header">
          <i class="fa-solid fa-location-dot location-icon"></i>
          <span class="location-label">DROP</span>
        </div>
        <div class="location-value">{{ dropoff || 'Kharghar' }}</div>
      </div>
    </div>
  </div>

  <!-- Schedule Section -->
  <div class="schedule-section mt-4">
    <div class="schedule-header">
      <i class="fa-regular fa-clock schedule-icon"></i>
      <h6 class="schedule-title">Schedule Your Trip</h6>
    </div>

    <div class="row g-3 mt-2">

      <!-- Pickup Date -->
      <div class="col-12 col-md-6">
        <label class="input-label">Date</label>
        <div class="schedule-input-group" (click)="openDatePicker(pickupDateInput)">
          <i class="fa-regular fa-calendar input-icon"
          ></i>
          <input
          #pickupDateInput
            type="date"
            class="schedule-input"
            [(ngModel)]="date"
            [min]="minDate"
            (change)="onFieldInput('date', date); onDateChange()"
          />
        </div>
        <div class="field-error small text-danger mt-1" *ngIf="dateInvalid">
          Please select date.
        </div>
      </div>

      <!-- Pickup Time -->
      <div class="col-12 col-md-6">
        <label class="input-label">Time</label>
        <div class="schedule-input-group">
          <input
            type="text"
            class="schedule-input"
            placeholder="Select Time"
            [(ngModel)]="displayTime"
            readonly
            (click)="toggleTimeList(); onFieldTouched('time')"
          />
          <i class="fa-regular fa-clock input-icon-right"></i>

          <ul class="time-list" *ngIf="showTimes">
            <li *ngFor="let t of timeOptions"
            [class.disabled]="isPickupTimeDisabled(t)"
            (click)="!isPickupTimeDisabled(t) && selectTime(t)">
              {{ t }}
            </li>
          </ul>
        </div>
        <div class="field-error small text-danger mt-1" *ngIf="timeInvalid">
          Please select time.
        </div>
      </div>

    </div>
  </div>

  <!-- RETURN DATE & TIME (Only for Rental & Outstation) -->
  <div
    class="schedule-section mt-4"
    *ngIf="selectedTripType === 'outstation' || selectedTripType === 'rental'"
  >
    <div class="schedule-header">
      <i class="fa-regular fa-clock schedule-icon"></i>
      <h6 class="schedule-title">Return Schedule</h6>
    </div>

    <div class="row g-3 mt-2">

      <!-- Return Date -->
      <div class="col-12 col-md-6">
        <label class="input-label">Return Date</label>
        <div class="schedule-input-group" (click)="openDatePicker(returnDateInput)">
          <i class="fa-regular fa-calendar input-icon" ></i>
          <input
          #returnDateInput
            type="date"
            class="schedule-input"
            [(ngModel)]="returnDate"
            [min]="date"
            (change)="onFieldInput('returnDate', returnDate)"
          />
        </div>
        <div class="field-error small text-danger mt-1" *ngIf="returnDateInvalid">
          Please select return date.
        </div>
      </div>

      <!-- Return Time -->
      <div class="col-12 col-md-6">
        <label class="input-label">Return Time</label>
        <div class="schedule-input-group">
          <input
            type="text"
            class="schedule-input"
            placeholder="Select Return Time"
            [(ngModel)]="returnDisplayTime"
            readonly
            (click)="toggleReturnTimeList()"
          />
          <i class="fa-regular fa-clock input-icon-right"></i>

          <ul class="time-list" *ngIf="showReturnTimes">
            <li
              *ngFor="let t of timeOptions"
              (click)="!isReturnTimeDisabled(t) && selectReturnTime(t)"
              [class.disabled]="isReturnTimeDisabled(t)"
            >
              {{ t }}
            </li>
          </ul>
        </div>
        <div class="field-error small text-danger mt-1" *ngIf="returnTimeInvalid">
          Please select return time.
        </div>
      </div>

    </div>
  </div>

  <!-- Next Button -->
  <div class="d-flex justify-content-between mt-4 flex-wrap">
     <button class="btn-back mt-2" (click)="navigatetoHome()">
        <i class="fa-solid fa-arrow-left"></i> Go Back
      </button>
    <button
      class="btn-next-modern mt-2"
      [disabled]="!isFormValid()"
      [class.disabled-looking]="!isFormValid()"
      (click)="onNextClick($event)"
    >
      Next: Passenger Details
      <i class="fa-solid fa-arrow-right"></i>
    </button>
  </div>
</div>

